import { NgModule } from '@angular/core';
import { PseiCoreModule } from '@psei/ng';
import { BreadcrumbsModule } from '@psei/ng/breadcrumbs';
import { DateTimePickerModule } from '@psei/ng/date-time-picker';
import { DialogModule } from '@psei/ng/dialog';
import { DrawerModule } from '@psei/ng/drawer';
import { IconModule } from '@psei/ng/icon';
import { OverlayModule } from '@psei/ng/overlay';
import { SelectModule } from '@psei/ng/select';
import { TableModule } from '@psei/ng/table';
import { DomToolsModule } from '@psei/ng/tools/dom-tools';
import { EventToolsModule } from '@psei/ng/tools/event-tools';
import { MessagesModule } from '@psei/ng/messages';

export const PSEI_NG_CUSTOM_MODULES = [
  BreadcrumbsModule,
  PseiCoreModule,
  DrawerModule,
  IconModule,
  SelectModule,
  DomToolsModule,
  DialogModule,
  EventToolsModule,
  DateTimePickerModule,
  TableModule,
  OverlayModule,
  MessagesModule
];

@NgModule({
  declarations: [],
  exports: [
    PSEI_NG_CUSTOM_MODULES,
  ]
})
export class PseiNgCustomModule {
}
